import renderStakeCheckingClosedAlert from "../Modals/Stake Checking/stake-checking-closed-alert";
import renderStakeCheckingInsufficientFundsAlert from "../Modals/Stake Checking/stake-checking-insufficient-funds-alert";

import { useModalContext } from "../../Contexts/ModalContext";
import { useAppUtilityContext } from "../../Contexts/AppUtilityContext";

import { useStakeDebit } from "../../CustomHooks/Queries";
import {
  useResetInsufficientBalanceForMembershipFeesAlert,
  useResetStakeCheckingClosedForNonComplianceAlert,
} from "../../CustomHooks/Mutations";

export default function NotificationWrapper({ children }) {
  const modalContext = useModalContext();
  const { modalVisibility } = modalContext;

  const { appUtilityProps } = useAppUtilityContext();

  const { mutate: ResetInsufficientBalanceForMembershipFeesAlert } =
    useResetInsufficientBalanceForMembershipFeesAlert();
  const { mutate: ResetStakeCheckingClosedForNonComplianceAlert } = useResetStakeCheckingClosedForNonComplianceAlert();

  useStakeDebit({
    enabled: !!appUtilityProps.authKey,
    onSuccess: ({ data }) => {
      if (data?.data?.stake_debit_notification?.show_insufficient_membership_fees && !modalVisibility) {
        renderStakeCheckingInsufficientFundsAlert(modalContext);
        ResetInsufficientBalanceForMembershipFeesAlert();
      }

      if (data?.data?.stake_debit_notification?.show_stake_account_closed_due_to_non_compliance && !modalVisibility) {
        renderStakeCheckingClosedAlert(modalContext);
        ResetStakeCheckingClosedForNonComplianceAlert();
      }
    },
  });

  return <>{children}</>;
}
